import pinyin from "pinyin";

const KEY = "__rT_dM__" + +new Date();
const R = new RegExp("(^|;)\\s*" + KEY + "=1");
const Y1970 = new Date(0).toUTCString();

export function getRootDomain() {
  let domain = document.domain || location.hostname;
  let list = domain.split(".");
  let len = list.length;
  let temp = "";
  let temp2 = "";

  while (len--) {
    temp = list.slice(len).join(".");
    temp2 = KEY + "=1;domain=." + temp;

    // try to set cookie
    document.cookie = temp2;

    if (R.test(document.cookie)) {
      // clear
      document.cookie = temp2 + ";expires=" + Y1970;
      return temp;
    }
  }
}

// https://github.com/30-seconds/30-seconds-of-code#isobject
export const isObject = (obj) => obj === Object(obj);
/**
 * 判断是否为http开头的URL
 *
 * @export
 * @param {String} str
 * @returns
 */
export function isHttp(str) {
  return /^http(?:|s)+:\/\//.test(str);
}

export function selectText() {
  console.log(window.getSelection());

  let selection = window.getSelection();
  if (!selection.isCollapsed) {
    let range = selection.getRangeAt(0);
    console.log(range);
  }
  try {
    let selecter = window.getSelection().toString();

    return [selecter, window.getSelection()];
  } catch (err) {
    let selecter = document.selection.createRange();

    return [selecter.text, document.selection];
  }
}

export function tooltip(text, x, y, w, h = 12) {
  let newDiv = document.createElement("div");
  newDiv.style.cssText = `left: ${x - w}px;top: ${y - 35}px;position:fixed; background: #000;color: #fff;font-size: 12px;padding: 2px 8px; border-radius: 4px;`;
  newDiv.style.top = y - 35 + "px";

  newDiv.className = "fn-tooltip";
  let newContent = document.createTextNode(text);
  let arrow = document.createElement("div");
  arrow.className = "popper__arrow";
  newDiv.appendChild(newContent);
  newDiv.appendChild(arrow);
  // <div :style="style" role="tooltip" aria-hidden="true" class="fn-tooltip el-tooltip__popper is-dark" style="">
  //   {{text}}
  //   <div x-arrow="" class="popper__arrow" style="left: 59px;"></div>
  // </div>
  document.body.appendChild(newDiv);
  return newDiv;
}
/**
 * 判断是否为http开头的URL
 *
 * @export
 * @param {String} str
 * @returns
 */
export function changePinyin(str, style) {
  let relust = pinyin(str, {
    style: style ? pinyin.STYLE_NORMAL : pinyin.STYLE_INITIALS // 设置拼音风格
  });
  return relust.map((a) => a[0]).join("");
}

/**
 * 转换样式大写替换及过滤子集下的对象
 *
 * @export
 * @param {Object} styles
 * @returns
 */
export function getStyles(styles) {
  let obj = {};
  for (let key in styles) {
    let temp = styles[key];
    if (isObject(temp) || temp === null || temp === undefined) continue;
    if (/[A-Z]/g.test(key)) {
      key = key.replace(/[A-Z]/g, function (s) {
        return "-" + s.toLowerCase();
      });
    }
    obj[key] = temp;
  }
  return obj;
}

/**
 * 随机生成字符串
 *
 * @export
 * @returns
 */
export function uuid() {
  return (
    (+new Date()).toString(36).slice(-5) + Math.random().toString(36).slice(-5)
  );
}

/**
 * 生成树形菜单
 * @param {Array} data 属性一维数组
 * @param {string} id 关联键名
 * @param {string} parentId 父辈键名
 * @export
 * @returns
 */
export function formatTreeData(data, id = "id", parentId = "parentId") {
  let map = data.reduce((a, i) => {
    a[i[id]] = i;
    return a;
  }, {});
  let list = [];
  data.forEach((i) => {
    if (i[parentId] !== null) {
      let parent = map[i[parentId]];
      if (parent === undefined) {
        list.push(i);
        // throw new Error(`${i[id]}'s parent ${i[parentId]} not found`)
        return;
      }
      let children = parent.children;
      if (!children) {
        children = parent.children = [];
      }
      children.push(i);
    }
  });
  return list;
}

export const isEmpty = (val) => {
  return val == null || !(Object.keys(val) || val).length;
};

export function isString(obj) {
  return Object.prototype.toString.call(obj) === "[object String]";
}

export function isHtmlElement(node) {
  return node && node.nodeType === Node.ELEMENT_NODE;
}

// 根据字段去重
export function removeRepeat(data, key = "same_id") {
  let dataKeys = {};
  return data.filter((a) => {
    if (!a[key]) {
      return true;
    } else if (dataKeys[a[key]]) {
      return false;
    } else {
      dataKeys[a[key]] = true;
      return true;
    }
  });
}

export function formatJson(data) {
  let obj = {
    ...data
  };
  for (let key in obj) {
    let relust = obj[key];
    switch (key) {
      case "date":
        relust = obj.date
          ? {
            to: obj.date[1],
            from: obj.date[0]
          }
          : undefined;
        break;
      case "emotion":
        relust = obj.emotion
          ? obj.emotion === 51
            ? {
              to: 10000,
              from: 5001
            }
            : {
              to: 5000,
              from: 0
            }
          : undefined;
        break;
      case "articletype":
        relust = obj.articletype ? obj.articletype.split(" ") : undefined;
        break;
      case "groupArticletype":
        relust = obj.groupArticletype
          ? obj.groupArticletype.split(" ")
          : undefined;
        break;
      case "original":
        relust =
          obj.original !== ""
            ? obj.original > 9
              ? {
                to: 20,
                from: 10
              }
              : {
                to: 9,
                from: 1
              }
            : undefined;
        break;
      case "imageCount":
        relust =
          obj.imageCount !== ""
            ? obj.imageCount
              ? {
                from: 1
              }
              : {
                to: 0,
                from: 0
              }
            : undefined;
        break;
      case "keyword":
        relust =
          obj.keyword !== ""
            ? obj.keyword.split(" ").map((k) => {
              return {
                word: k
              };
            })
            : [];
        break;
      case "anyKey":
        relust =
          obj.anyKey !== ""
            ? (relust =
              obj.anyKey !== "" ? [{ word: obj.anyKey, andOrnot: 1 }] : [])
            : [];
        break;
      case "exceptKey":
        relust =
          obj.exceptKey !== ""
            ? obj.exceptKey.split(" ").map((k) => {
              return {
                word: k,
                andOrnot: 2
              };
            })
            : [];
        break;
      default:
        break;
    }
    obj[key] = relust;
  }
  if (obj.anyKey) {
    obj.keyword = obj.keyword.concat(obj.anyKey);
  }
  if (obj.exceptKey) {
    obj.keyword = obj.keyword.concat(obj.exceptKey);
  }
  return obj;
}

export function filterEmptyObj(params) {
  let relust = {};
  for (let key in params) {
    let tmp = params[key];
    if (isObject(tmp)) {
      if (isEmpty(tmp)) continue;
      relust[key] = params[key];
    } else if (params[key]) {
      relust[key] = params[key];
    }
  }
  return relust;
}

// '../styles/base/var.less' 参考值CSS源
/**
 * 计算rem 128参考字体大小
 * @param {String} px
 * @returns
 */
export function rem(px) {
  return px / 128 + "rem";
}
/**
 * 计算vw 1280参考尺寸
 * @param {String} px
 * @returns
 */
export function vw(px) {
  return (px / 1280) * 100 + "vw";
}
export function splitPotos(str) {
  // http://fwimage.cnfanews.com/websiteimg/2019/20190612/12749/bd94945987769bc55a5706b3a72e3a46.jpg%D%Whttp://fwimage.cnfanews.com/websiteimg/2019/20190612/12749/9ad8073d43a2a85e8a8428f3764ac61d.jpg%D%W"
  return str ? str.split("%D%W") : [];
}

const URLREGEX =
  /[^('|")](http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?/g;

export function formatHtml(html, words) {
  if (!html) return "";
  if (typeof words === "string") words = words.split(",");
  // words.forEach(key => {
  //   html = html.replace(`/${key}/g`, `<b class="fn-artices-b>${key}</b>`)
  // })
  html = html.replace(
    new RegExp(`(${words.join("|")})`, "g"),
    `<b class="fn-artices-b">$1</b>`
  );
  html = html.replace(URLREGEX, (a) => {
    // console.log(RegExp.$2, RegExp.$1, a)
    let str = a.substr(1);
    return `<a href="${str}" target=_blank>${str}</a>`;
  });
  return html;
}

export function formatHtml2(html, words) {
  //
  if (!html) return "";
  let relust = "";
  if (words && words.length > 0) {
    if (typeof words === "string") relust = words.split(",");
    if (typeof words === "object") {
      relust = [];
      words.forEach((word) => {
        if (Array.isArray(word)) {
          word.forEach((item) => {
            if (
              relust.indexOf(item.value) < 0 &&
              item.value !== "" &&
              item.value !== null
            ) {
              item.wz = item.loacation.split("-");
              relust.push(item);
            }
          });
        } else {
          if (
            relust.indexOf(word.value) < 0 &&
            word.value !== "" &&
            word.value !== null
          ) {
            word.wz = word.loacation.split("-");
            relust.push(word);
          }
        }
      });
    }
    relust.sort((a, b) => {
      return b.wz[0] - a.wz[0];
    });
    relust.forEach((item) => {
      let start = html.substring(0, item.wz[0]);
      let center = html.substring(item.wz[0], Number(item.wz[1]) + 1);
      let end = html.substring(Number(item.wz[1]) + 1);
      center = `<b class="fn-artices-c">${center}</b>`;
      html = start + center + end;
    });
  }
  html = html.replace(URLREGEX, (a) => {
    // console.log(RegExp.$2, RegExp.$1, a)
    let str = a.substr(1);
    return `<a href="${str}" target=_blank>${str}</a>`;
  });
  console.log(html);
  return html;
}

export function formatHtml2wait(html, words) {
  console.log(words);
  if (!html) return "";
  let relust = "";
  if (words && words.length > 0) {
    if (typeof words === "string") relust = words.split(",");
    if (typeof words === "object") {
      relust = [];
      words.forEach((word) => {
        if (Array.isArray(word)) {
          word.forEach((item) => {
            if (
              relust.indexOf(item.value) < 0 &&
              item.value !== "" &&
              item.value !== null
            ) {
              relust.push(item.value);
            }
          });
        } else {
          if (
            relust.indexOf(word.value) < 0 &&
            word.value !== "" &&
            word.value !== null
          ) {
            relust.push(word.value);
          }
        }
      });
    }
    console.log(relust);
    if (relust && relust.length) {
      html = html.replace(
        new RegExp(`(${relust.join("|")})`, "g"),
        `<b class="fn-artices-c">$1</b>`
      );
    }
  }
  // words.forEach(key => {
  //   html = html.replace(`/${key}/g`, `<b class="fn-artices-b>${key}</b>`)
  // })
  html = html.replace(URLREGEX, (a) => {
    // console.log(RegExp.$2, RegExp.$1, a)
    let str = a.substr(1);
    return `<a href="${str}" target=_blank>${str}</a>`;
  });
  return html;
}
